export const EXERCISE_BASE = 'exercise/EXERCISE_BASE';
export const EXERCISE_QUERY = 'exercise/EXERCISE_QUERY';
export const LIBRARY_LOADING = 'exercise/LIBRARY_LOADING';
export const LIBRARY_LOADED = 'exercise/LIBRARY_LOADED';
export const FILTER_LOADING = 'exercise/FILTER_LOADING';
export const FILTER_LOADED = 'exercise/FILTER_LOADED';
